import { StyledDropdownMenuOption } from './atoms';
import { NOT_IN_USE_TAG_MESSAGE } from '../constants';
import { RedactedFieldDisplay } from '@ardoq/renderers';
import { Tag } from '@ardoq/status-ui';

type DropdownMenuOptionProps = {
  label: string;
  isActive: boolean;
  isUnused?: boolean;
  isConfidential?: boolean;
  onClick?: () => void;
};

export const DropdownMenuOption = ({
  label,
  isUnused,
  isConfidential,
  isActive,
  onClick,
}: DropdownMenuOptionProps) => (
  <StyledDropdownMenuOption
    label={label}
    isChecked={isActive}
    onClick={onClick}
    key={label}
    rightContent={
      isConfidential ? (
        <RedactedFieldDisplay />
      ) : isUnused ? (
        <Tag label={NOT_IN_USE_TAG_MESSAGE} />
      ) : undefined
    }
    isDisabled={isUnused || isConfidential}
    keepRightContentActive
    truncateTitle
  />
);
